import React, { useState, useEffect } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import './SignatureModal.css';

const modules = {
    toolbar: [
        ['bold', 'italic', 'underline', 'strike'],
        [{ 'color': [] }],
        ['link', 'image'],
        ['clean']
    ]
};

const formats = ['bold', 'italic', 'underline', 'strike', 'color', 'link', 'image'];

const SignatureModal = ({ isOpen, toggle, signature, onSave, saving }) => {
    const [content, setContent] = useState('');

    useEffect(() => {
        if (isOpen) setContent(signature || '');
    }, [isOpen, signature]);

    const handleSave = () => {
        onSave(content);
    };

    return (
        <Modal isOpen={isOpen} toggle={toggle} className="signature-modal" size="lg">
            <ModalHeader toggle={toggle}>Email Signature</ModalHeader>
            <ModalBody>
                <p className="signature-modal-desc">Create your email signature. This will be automatically added to emails sent from this sales account.</p>
                <div className="signature-layout">
                    <div className="signature-editor-section">
                        <div className="signature-editor-container">
                            <ReactQuill
                                theme="snow"
                                value={content}
                                onChange={setContent}
                                modules={modules}
                                formats={formats}
                                placeholder="Enter your signature..."
                            />
                        </div>
                    </div>
                    <div className="signature-preview-section">
                        <label className="signature-preview-label">Preview:</label>
                        <div className="signature-preview-content" dangerouslySetInnerHTML={{ __html: content || '<span class="signature-placeholder">Your signature will appear here...</span>' }} />
                    </div>
                </div>
            </ModalBody>
            <ModalFooter>
                <Button color="secondary" onClick={toggle}>Cancel</Button>
                <Button color="primary" onClick={handleSave} disabled={saving}>
                    {saving ? 'Saving...' : 'Save Signature'}
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default SignatureModal;
